import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getRouteSectionKey } from "@/shared/components/RouteTransition/routeSection";
import { reloadPage } from "../utils/appVersion";
import {
  getDeployedVersion,
  isAppUpdateAvailable,
} from "../stores/appVersionStore";

/**
 * SA-1416: com versão nova no ar, a próxima troca de SEÇÃO (/chats → /contatos)
 * carrega o código novo; a URL já é a do destino, então a pessoa cai onde ia.
 * Dentro da mesma seção não recarrega: trocar de conversa (/chats/:id) é
 * navegação, e recarregar ali repintaria o inbox e perderia o que está aberto.
 * É a mesma régua da animação de troca de página (`getRouteSectionKey`).
 */
export function useReloadOnNavigation() {
  const { pathname } = useLocation();
  const previous = useRef(pathname);

  useEffect(() => {
    const sectionChanged =
      getRouteSectionKey(previous.current) !== getRouteSectionKey(pathname);
    previous.current = pathname;
    if (sectionChanged && isAppUpdateAvailable()) {
      reloadPage(getDeployedVersion());
    }
  }, [pathname]);
}
